import React from 'react'
import renderHTML from 'react-render-html'
import './styles.scss'

const Video = props => {
  const embedURL = props.url
  // console.log (embedURL)
  return (
    <>
      {/* <div className='intro'>
        {props.icon !== null && <i className={`icon ${props.icon}`} />}
        <div className='wrapper'>
          {props.overline !== null && (
            <div className='overline'>{props.overline}</div>
          )}
          {props.scene !== null && <div className='scene'>{props.scene}</div>}
        </div>
      </div> */}
      <div className='videoWrapper'>
        <iframe
          src={embedURL}
          allowFullScreen
          frameBorder='0'
          className='iframe'
          allow='autoplay'
          title='example'
        />
      </div>

      {props.caption !== null && (
        <figcaption>{props.caption}<div className='source'>{props.source}</div></figcaption>
      )}
    </>
  )
}
export default Video
